import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Form, Question } from 'utils';

type ReturnType = Promise<AxiosResponse<Form>>;

interface AddSectionPayload {
    uuid: string;
    question: Question;
    name: string;
}

const addSectionToForm = (formId: string, payload: AddSectionPayload): ReturnType => {
    return Request.post(`/data/forms/${formId}/sections`, payload);
};

export default addSectionToForm;
